import { Col, Row } from "react-bootstrap";
import React, { useContext, useEffect, useState } from "react";
import { ThemeColorsEnum, UnitOfMeasurementsEnum } from "../../constants/enums";

import AddIcon from "@mui/icons-material/Add";
import AppErrorMessage from "./ErrorMessage";
import AppFormLabel from "./FormLabel";
import { AuthContext } from "../../context/contextProvider";
import CircleButton from "../buttons/CircleButton";
import FormFieldContainer from "./FormFieldContainer";
import { Link } from "react-router-dom";
import WorkOrderProduct from "./WorkOrderProduct";
import { useFormikContext } from "formik";

const FormWorkOrderProducts = ({
  availableProducts,
  completing,
  directDrop,
  errorFieldName,
  label = null,
  LabelComponent,
  name,
  onSelectProduct = () => {},
  required,
  visible = true,
  ...otherProps
}) => {
  const formik = useFormikContext();
  const { errors, handleBlur, setFieldValue, touched, values } = formik;

  const [productsList, setProductsList] = useState(values[name]);

  const { branchSettings } = useContext(AuthContext);

  useEffect(() => {
    setProductsList(values[name]);
  }, [values[name]]); // eslint-disable-line react-hooks/exhaustive-deps


  const handleAddProduct = () =>
    setProductsList([
      ...productsList,
      {
        id: 0,
        currentPercentage: "",
        productId: 0,
        quantity: directDrop ? branchSettings?.directDropDefaultQuantity : "",
        unitOfMeasurement: UnitOfMeasurementsEnum.liters,
      },
    ]);

  const handleRemoveLastProduct = () => {
    const removed = productsList?.pop();
    const updatedProductList = productsList.filter((x) => x !== removed);
    setProductsList(updatedProductList);
    setFieldValue(name, updatedProductList);
  };

  const handleSelectProduct = (index) => (product) => {
    setFieldValue(`${name}[${index}]`, product);
    onSelectProduct(product, formik);
  };

  if (!visible) return null;

  return (
    <FormFieldContainer>
      <Row>
        <Col lg={10}>
          <AppFormLabel label={label} required={required} visible={!!label} />
          {LabelComponent}
        </Col>
        <Col lg={2} className="text-right">
          {/* <Link className="text-default" to="#">
            <i className="fa fa-plus-circle"></i>
          </Link> */}
          <CircleButton
            color={ThemeColorsEnum.quaternary}
            size={25}
            // style={{ backgroundColor: "#eaeaea" }}
            IconComponent={() => (
              <AddIcon className="cur-pointer" style={{ fontSize: 20 }} />
            )}
            onClick={handleAddProduct}
          />
        </Col>
      </Row>
      {productsList?.map((workOrderProduct, index) => (
        <WorkOrderProduct
          className="mb-1"
          completing={completing}
          directDrop={directDrop}
          key={index}
          name={`${name}[${index}]`}
          onBlur={() => handleBlur(name)}
          onSelected={handleSelectProduct(index)}
          products={availableProducts}
          workOrderProduct={workOrderProduct}
        />
      ))}
      <Row>
        <Col sm={8}>
          <AppErrorMessage
            error={errors[errorFieldName]}
            visible={!!touched[name] && !!errors[errorFieldName]}
          />
        </Col>
        {productsList?.length > 1 && (
          <Col className="text-right" sm={4}>
            <Link onClick={handleRemoveLastProduct} to="#">
              Remove
            </Link>
          </Col>
        )}
      </Row>
    </FormFieldContainer>
  );
};

export default FormWorkOrderProducts;
